/* eslint-disable import/no-unresolved */
import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/effect-coverflow';

import { EffectCoverflow } from 'swiper';

import { clients } from '../constants/clients';
import { quotes, ellipse } from '../assets';

const Testimonials = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section
      className="pt-[80px] pb-[100px] bg-none xl:bg-testimonials xl:dark:bg-testimonialsDark bg-no-repeat bg-right
      bg-lightGray dark:bg-black3 transition"
      id="testimonials"
    >
      <div className="wrapper relative">
        <div className="section-title section-title4 pb-[60px] mt-2.5 dark:before:bg-primaryOrange/25">
          <h2 className="relative text-[32px] md:text-[40px] font-extrabold md:font-bold text-primaryBlack dark:text-white">
            What they say about me
          </h2>
        </div>

        <div className="max-w-[700px] min-h-[230px] mx-auto">
          <p className="mx-auto text-center text-primaryBlack/50 dark:text-white text-xs md:text-sm pb-[60px] font-medium !leading-8">
            {clients[activeIndex].desc}
          </p>
        </div>
        <div className="container">
          <Swiper
            effect="coverflow"
            grabCursor
            centeredSlides
            loop="true"
            onSlideChange={(e) => setActiveIndex(e.realIndex)}
            coverflowEffect={{
              rotate: 0,
              stretch: 0,
              depth: 50,
              modifier: 2.3,
            }}
            breakpoints={{
              280: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              600: {
                slidesPerView: 3,
                spaceBetween: 78,
              },
            }}
            modules={[EffectCoverflow]}
          >
            {clients.map((client, index) => (
              <SwiperSlide key={index}>
                <img src={client.image} alt="client" className="rounded-full" />
              </SwiperSlide>
            ))}
          </Swiper>
          <p className="text-center pt-[27px] text-primaryBlack dark:text-white text-base font-bold">{clients[activeIndex].name}</p>
          <p className="text-center text-gray3 text-xs font-medium pt-1.5">{clients[activeIndex].postition}</p>
        </div>

        <img src={quotes} alt="quotes" className="absolute top-0 left-5 hidden lg:block" />
        <img src={ellipse} alt="elipse" className="absolute bottom-[-30px] left-8 hidden lg:block" />
      </div>
    </section>
  );
};

export default Testimonials;
